import { THEME_LIST, type Theme } from "@/components/layouts/navbar/Themes";

/** Fonds du plan proposés (thèmes « dark » et « light » des réglages). */
export type PlanBackground = Theme["name"];

export const PLAN_BACKGROUNDS: readonly PlanBackground[] = THEME_LIST.map(
  (theme) => theme.name,
);

/** Couleur de fond d'un thème, au format attendu par le moteur (0xRRGGBB). */
export function themeBackgroundHex(theme: Theme): number {
  const [r, g, b] = theme.bgColor;
  return (r << 16) | (g << 8) | b;
}

export function findTheme(name: PlanBackground): Theme | undefined {
  return THEME_LIST.find((theme) => theme.name === name);
}
